import Debug from 'debug';
import { QuizPlayerStateMachineAbstractState,
  QuizMode,
  QuizPlayerStateMachineCommonEvents} from './quiz-player-state-machine-state'
import { StateChangedListener } from '@/app/shared/state-machine';

const debug = Debug('child-state-machine-handler')

interface HandledStateMachine {
  addStateChangedListener(listener: StateChangedListener<any>): number
  removeStateChangedListener(token: number): void
  reset(): void
  error: unknown
}

interface Events extends QuizPlayerStateMachineCommonEvents {
  onTryAgain: (mode: QuizMode) => void
  onContinueError: () => void
}

export class ChildStateMachineHandler {

  private listenerToken: number
  private tryAgainRequest: QuizMode | '' = ''

  constructor(private name: string,
              private stateMachine: HandledStateMachine,
              private parent: QuizPlayerStateMachineAbstractState<Events>) {
  }

  enter() {
    this.listenerToken = this.stateMachine.addStateChangedListener(
      (state) => this.childStateChanged(state))
  }

  exit() {
    this.stateMachine.removeStateChangedListener(this.listenerToken)
  }

  private childStateChanged(state: string) {
    debug(`child ${this.name} state changed`, state, this.tryAgainRequest)

    if (state === 'initial' && this.tryAgainRequest) {
      const mode = this.tryAgainRequest
      this.tryAgainRequest = ''
      this.parent.triggerEvent(events => events.onTryAgain(mode))
    }

    if (state === 'canceled') {
      debug(`child ${this.name} state machine canceled`)
      this.parent.triggerEvent(events => events.onCanceled())
    }

    if (state === 'error') {
      debug(`child ${this.name} state machine error`, this.stateMachine.error)

      if (this.stateMachine.error === 'continue-question-not-found') {
        debug(`child ${this.name} state machine could not continue`)
        this.stateMachine.reset()
        this.parent.triggerEvent(events => events.onContinueError())
      } else {
        this.parent.triggerEvent(events => events.onError(this.stateMachine.error))
      }
    }
  }

  tryAgain(mode: QuizMode) {
    debug('tryAgain', mode)
    this.tryAgainRequest = mode
    this.stateMachine.reset()
  }
}
